import { render, staticRenderFns } from "./ContentOverviewCard.vue?vue&type=template&id=cd5f6ffc&scoped=true&"
import script from "./ContentOverviewCard.vue?vue&type=script&lang=js&"
export * from "./ContentOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ContentOverviewCard.vue?vue&type=style&index=0&id=cd5f6ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5f6ffc",
  null
  
)

export default component.exports